const ArrowRight01Icon = /*#__PURE__*/ [
  ["path", { d: "M9.00005 6C9.00005 6 15 10.4189 15 12C15 13.5812 9 18 9 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { ArrowRight01Icon as default };
//# sourceMappingURL=ArrowRight01Icon.js.map
